import React from "react";
import { useLanguage } from "../i18n/LanguageProvider";

const VARIANTS = {
  eliminated: { rank: "×", stars: 0 },
  third: { rank: "3", stars: 1 },
  second: { rank: "2", stars: 2 },
  winner: { rank: "1", stars: 3 },
};

export default function TournamentResultModal({ variant = "eliminated", onClose }) {
  const { t } = useLanguage();
  const config = VARIANTS[variant] || VARIANTS.eliminated;

  return (
    <div className="vq-tournament-result-overlay" onClick={onClose} role="presentation">
      <section
        className={`vq-tournament-result-modal vq-tournament-result-modal--${variant}`}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="vq-tournament-result-title"
      >
        <button
          type="button"
          className="vq-tournament-result-close"
          onClick={onClose}
          aria-label={t("common.close")}
        >
          ×
        </button>

        <div className="vq-tournament-result-emblem" aria-hidden="true">
          <span>{config.rank}</span>
        </div>

        <h2 id="vq-tournament-result-title">
          {t(`dashboard.resultModal.${variant}.title`)}
        </h2>

        <div className="vq-tournament-result-divider" aria-hidden="true">
          {config.stars > 0 && (
            <span>{Array.from({ length: config.stars }, () => "★").join(" ")}</span>
          )}
        </div>

        <p className="vq-tournament-result-copy">
          {t(`dashboard.resultModal.${variant}.text`)}
        </p>

        {variant === "eliminated" && (
          <p className="vq-tournament-result-thanks">
            {t("dashboard.resultModal.eliminated.thanks")}
          </p>
        )}

        <button type="button" className="vq-tournament-result-ok" onClick={onClose}>
          {t("common.ok")}
        </button>
      </section>
    </div>
  );
}
